import { useToken } from "@chakra-ui/system";
import type { TopClient } from "@src/__generated__/urql-graphql";
import { observer, useLocalObservable } from "mobx-react-lite";
import { useEffect } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { TopGraphTooltipContent } from "../../../common/graphs/top-graph-tooltip";
import { getFillColor } from "../../../common/graphs/utils";
import { TopClientGraphStore } from "./store";

type Props = {
  data: TopClient[];
};

export const TopClientsGraph = observer(function TopClientsGraph({
  data,
}: Props) {
  const colors = useToken("colors", [
    "jade.400",
    "red.400",
    "riptide.500",
    "orange.400",
    "yellow.400",
    "riptide.400",
    "pink.400",
    "riptide.300",
    "cyan.400",
    "green.400",
    "purple.400",
    "riptide.200",
  ]);
  const { store } = useLocalObservable(() => ({
    store: new TopClientGraphStore(data),
  }));

  useEffect(() => {
    store.setData(data);
  }, [data]);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={store.dataForGraph}>
        <XAxis dataKey="total_value_formatted" fontSize="8px" />
        <Tooltip
          content={<TopGraphTooltipContent type="client" />}
          wrapperStyle={{
            zIndex: 1,
          }}
        />
        {store.allBrands.map((brand, index) => (
          <Bar
            key={`${brand.value}-${brand.name}`}
            dataKey={brand.name}
            stackId="a"
            name={brand.name}
            fill={getFillColor(colors, index)}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
});
